import React, { useEffect, useState, useRef } from 'react';
import styles from './detailsBox.module.scss';
import timeIcon from '../../../assets/icons/programs/major/timeStamp.svg';
import calendarIcon from '../../../assets/icons/programs/major/calendar.svg';
import studentIcon from '../../../assets/icons/programs/major/student.svg';
import policeManIcon from '../../../assets/Imagess/policeMan.svg';
import moment from 'moment';

import languageIcon from '../../../assets/icons/programs/major/languages.svg';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import Separator from '../../Atoms/separator/Separator';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import ApplicantsTab from '../../Atoms/Tabs/InfoTab';

import emailIcon from '../../../assets/Imagess/GreenEmail.svg';
import phoneIcon from '../../../assets/Imagess/GreenPhone.svg';
import AttachmentsIcon from '../../../assets/Imagess/AttachmentsIcon.svg';
import FormIcon from '../../../assets/Imagess/FormIcon.svg';
import Buttons from '../../Atoms/Buttons/Buttons';
import InfoCard from '../../Atoms/Cards/InfoCard';
import { useNavigate } from 'react-router-dom';
import BackIcon from '../../../assets/Imagess/BackIcon.svg';
import ExportIcon from '../../../assets/Imagess/exportIcon.svg';
import PrintIcon from '../../../assets/Imagess/printIcon.svg';
import Attachments from './Attachments';

import DownloadAllIcon from '../../../assets/Imagess/DownloadAllIcon.svg';
import {
  useDownloadAllAttachments,
  useDownloadSelectedDocuments,
} from '../../../Hooks/Applications';
import MoreButton from '../../Molecules/Custom/MoreButton';
import ReactToPrint from 'react-to-print';
import printicon from '../../../assets/Imagess/printIcon.svg';
import { isEmpty } from 'lodash';

function DetailsBox({
  data,
  mode,
  setDetails,
  applicantId = '',
  setMoveRight,
  refetchSingleApplicant,
}) {
  const navigate = useNavigate();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const downloadSelectedDocuments = useDownloadSelectedDocuments();
  const menuItems = [
    // {
    //   label: "Export",
    //   icon: ExportIcon,
    //   // onClick: () => navigate("/home/programs/edit/11"),
    // },
    {
      label: 'طباعة ',
      icon: PrintIcon,
      onClick: () => {},
    },
  ];

  const [info, setInfo] = useState(null);
  const [selected, setSelected] = useState('onlineForm');
  const [academic_Records, setAcademic_Records] = useState(`: No Attachment`);
  let componentRef = useRef();

  const tabs = [
    {
      index: 0,
      name: 'onlineForm',
      text: 'Online Form',
      icon: FormIcon,
    },
    {
      index: 1,
      name: 'attachments',
      text: 'Attachments',
      icon: AttachmentsIcon,
    },
  ];

  useEffect(() => {
    if (data) {
      if (data.applicantFiles.length) {
        setAcademic_Records(' ' + data.applicantFiles.length);
      }
      let programInfo = [
        {
          Degree:
            data.intersted && data.intersted.Degree
              ? data.intersted.Degree
              : 'N/A',
          Term:
            data.intersted && data.intersted.selectedTerm_Display
              ? data.intersted.selectedTerm_Display
              : 'N/A',
          Visa:
            data.intersted && data.intersted.Visa ? data.intersted.Visa : 'N/A',
          Applying_As:
            data.intersted && data.intersted.applicationStart_Display
              ? data.intersted.applicationStart_Display
              : 'N/A',
        },
      ];
      let addressInfo = [
        {
          Street_Name: data.addressInfo[0].streetName,
          Country: data.addressInfo[0].country_DisplayEN,
          'City / State': data.addressInfo[0].cityState_DisplayEN,
          'Po,Box': data.addressInfo[0].pobox,
          Zip_Code: data.addressInfo[0].zipCode,
        },
      ];
      let personalInfo = [
        {
          Fullname_English: data.intersted.fullName_EN,
          Fullname_Arabic: data.intersted?.fullName_AR,
          Email: data.intersted?.email,
          Emirates_ID: data.intersted?.emiratesId,
        },
        {
          Date_Of_birth: moment(data.intersted.dob).format('DD/MM/YYYY'),
          Gender: data.intersted?.gender_DisplayEN,
          Nationality: data.intersted?.nationality_DisplayEN,
          Mobile: data.intersted?.mobile,
          Telephone: data.intersted?.phoneNumber,
        },
        {
          Place_Of_Birth: data.intersted.placeOfBirth ?? 'N/A',
          Heard_About_Us: data.intersted.howDoYouHear_DisplayEN ?? 'N/A',
          Employed: data.intersted.isEmployed ? 'Yes' : 'No',
          People_Of_Determination: data.intersted?.isPeopleOfDetermination
            ? 'Yes'
            : 'No',
          Requires_Assistance: data.intersted?.Assistance ?? 'N/A',
        },
      ];
      let academicInfo = [
        {
          Last_Activities: data?.applicantAcademicInfo[0]?.lastActivities,
          Country_Graduate_From:
            data.applicantAcademicInfo[0]?.country_Display ?? 'N/A',
          Education_Institution:
            data.applicantAcademicInfo[0]?.educationalInstitution ?? 'N/A',
        },
        {
          Degree: data.applicantAcademicInfo[0]?.degree_Display ?? 'N/A',
          Graduation_Year:
            data.applicantAcademicInfo[0]?.graduationYear ?? 'N/A',
          'List_Of_Any_Advanced_Courses_Such_As_`A`Levels,Ap,Clep,Ib_Diploma':
            data.applicantAcademicInfo[0]?.advancedCourses ?? 'N/A',
        },
      ];

      setInfo({
        fullName: data.intersted.fullName_EN,
        email: data.intersted.email,
        phone: data.intersted.mobile,
        program: data.intersted.applicationStart_Display,
        address: addressInfo,
        programInfo: programInfo,
        personalInfo: personalInfo,
        academicInfo: academicInfo,
        applicantFiles: data.applicantFiles,
      });
    }
  }, [data, academic_Records]);

  //-------------------------------------------------------------

  const downloadAttachment = useDownloadAllAttachments(applicantId);
  // const handleDownloadAll = async (contentType) => {
  //   try {
  //     var data = await downloadAttachment.mutateAsync();

  //     if (data.data instanceof Blob) {
  //       const blob = new Blob([data.data], {
  //         type: contentType,
  //       });
  //       const link = document.createElement("a");
  //       link.href = window.URL.createObjectURL(blob);
  //       link.download = "All Attached Files";
  //       link.click();

  //       window.URL.revokeObjectURL(link.href);
  //     } else {
  //       console.error("Unexpected data type. Expected string.");
  //     }
  //   } catch (error) {
  //     console.error("Error downloading file:", error);
  //   }
  // };

  const handleDownloadAll = async () => {
    try {
      const downloadResult = await downloadAttachment.mutateAsync(applicantId);

      const blob = new Blob([downloadResult.data], { type: 'application/zip' });

      const contentDisposition = downloadResult.headers['content-disposition'];
      let fileName = `${data?.intersted?.fullName_EN}.document.zip`;

      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (match != null) {
          fileName = match[1].replace(/['"]/g, '');
        }
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const handleDownloadSelectedDocument = async () => {
    const applicantId = data?.intersted?.applicantId;

    try {
      const downloadResult = await downloadSelectedDocuments.mutateAsync({
        applicantId: applicantId,
        applicantFilesId: selectedFiles,
      });

      console.log(downloadResult);
      // Ensure the response is of type 'application/zip'
      if (downloadResult) {
        const blob = new Blob([downloadResult], { type: 'application/zip' });
        const contentDisposition =
          downloadResult.headers['content-disposition'];
        let fileName = `Documents.zip`;

        // Extract filename from content-disposition
        if (contentDisposition) {
          const match = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          if (match != null) {
            fileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
          }
        }

        // Create a link element to download the file
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        // const text = await downloadResult.text();
        // const errorResponse = JSON.parse(text);
        // console.error("Error downloading file:", errorResponse);
      }
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  console.log('vfmnvkfd', selectedFiles);
  return (
    <>
      <div
        className={`${styles['parentContainer']}`}
        id={'PrintDetails'}
        ref={(el) => (componentRef = el)}
      >
        <img
          src={BackIcon}
          className={`${styles['BackIcon']} ${styles['no-print']}`}
          onClick={() => {
            setDetails('');
            setMoveRight(false);
          }}
          alt={''}
        />
        <div className={`${styles['major-box']} `}>
          <div className={`${styles['box-side']} `}>
            <img src={policeManIcon} className={` ${styles['leftImg']} `} />
          </div>
          <div className={`${styles['box-body']} `}>
            <h3>{info && info.fullName}</h3>
            <div className={styles['info-row']}>
              <div className={styles['info-row-item']}>
                <img src={emailIcon} />
                <p className={styles['info-text']}>{info && info.email}</p>
              </div>
              <div className={styles['info-row-item']}>
                <img src={phoneIcon} />
                <p className={styles['info-text']}>{info && info.phone}</p>
              </div>
            </div>
            <hr />
            {/* <div>
              <h4>Program</h4>
              <span> {info && info.program}</span>
            </div> */}
          </div>
        </div>
        <div className={`${styles['tab-select-container']} ${styles['row']}`}>
          <div className={`${styles['tab-container']} ${styles['w-90']}`}>
            {tabs.map((tab) => (
              <ApplicantsTab
                key={tab.index}
                text={tab.text}
                icon={tab.icon}
                handleOnClick={() => {
                  setSelected(tab.name);
                }}
                active={tab.name === selected ? true : false}
                shadowed={false}
              />
            ))}
          </div>
          {selected === 'onlineForm' ? (
            <div
              style={{ position: 'absolute', right: '40px', marginTop: '25px' }}
              className={`  ${styles['no-print']} `}
            >
              <MoreButton icon={moreInfo} top={1} right={30}>
                <div className={styles['in-container']}>
                  {/* <div>
                    <div>
                      {" "}
                      <img src={ExportIcon} alt="profile" /> <span>Export</span>
                    </div>{" "}
                  </div> */}
                  <div>
                    <ReactToPrint
                      trigger={() => (
                        <div>
                          <img src={PrintIcon} alt="Details" />
                          <span>Print</span>
                        </div>
                      )}
                      content={() => componentRef}
                    />
                  </div>
                </div>
              </MoreButton>
            </div>
          ) : selectedFiles?.length > 0 ? (
            <Buttons
              text={'Download'}
              handleOnClick={handleDownloadSelectedDocument}
              rounded
              icon={DownloadAllIcon}
              style={{
                position: 'absolute',
                right: '10px',
                marginTop: '12px',
                padding: '15px',
                fontSize: '20px',
                fontFamily: 'BukraBold',
              }}
              width={232}
            />
          ) : (
            <Buttons
              text={'Download All'}
              handleOnClick={handleDownloadAll}
              rounded
              icon={DownloadAllIcon}
              style={{
                position: 'absolute',
                right: '10px',
                marginTop: '12px',
                padding: '15px',
                fontSize: '20px',
                fontFamily: 'BukraBold',
              }}
              width={232}
            />
          )}
        </div>

        {selected === 'onlineForm' ? (
          <div className={`${styles['row']} `}>
            <InfoCard
              title="Personal Information"
              values={info && info.personalInfo}
              width={'w-100'}
              column={3}
            />
            <InfoCard
              title="Mailing Address"
              values={info && info.address}
              width={'w-49'}
              column={1}
            />
            <InfoCard
              title="Program Information"
              values={info && info.programInfo}
              width={'w-49'}
            />
            <InfoCard
              title="Academic Information"
              values={info && info.academicInfo}
              width={'w-100'}
              column={2}
            />
          </div>
        ) : (
          <Attachments
            title="Attachments"
            data={info && info.applicantFiles}
            refetchSingleApplicant={refetchSingleApplicant}
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
          />
        )}
      </div>
    </>
  );
}

export default DetailsBox;
